export default "__VITE_ASSET__3azBSo9___"